<formly-field
  *ngFor="let field of field.fieldGroup; let i = index"
  [field]="field"
  [attr.id]="props.id ? props.id + '_' + i : null"
></formly-field>
